import { Component, inject } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { ThemeService } from '@aurrica-web/core-data';
import {
  LANDING_FLEET_LOGIN_URL,
  LANDING_FREIGHT_LOGIN_URL,
} from '../landing-app-links';

@Component({
  selector: 'app-footer-section',
  standalone: true,
  imports: [TranslocoModule],
  templateUrl: './footer-section.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class FooterSectionComponent {
  year = new Date().getFullYear();
  themeService = inject(ThemeService);
  protected readonly freightLoginUrl = LANDING_FREIGHT_LOGIN_URL;
  protected readonly fleetLoginUrl = LANDING_FLEET_LOGIN_URL;
}
